import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { DURATIONS } from '../utils/time-utils';

@Component({
  selector: 'duration-select',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, MatOptionModule, ReactiveFormsModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DurationSelectComponent),
      multi: true
    }
  ],
  templateUrl: './duration-select.component.html',
})
export class DurationSelectComponent implements ControlValueAccessor, OnInit {
  @Input() required = false;
  @Input() readonly = false;
  @Input() formFieldClass: string = '';


  control = new FormControl<string | null>(null);

  constructor() {
    this.control.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }


  ngOnInit() {
    // set the required validator if the selection is required.
    if (this.required) {
      this.control.setValidators(Validators.required);
    }
  }

  onChange = (value: string | null) => { };
  onTouched = () => { };

  writeValue(value: string | null): void {
    this.control.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setValue(value: string | null) {
    this.control.setValue(value);
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  getDurations() {
    return DURATIONS
  }

}
